


















import {Component, Prop} from 'vue-property-decorator';
import CompanyMixin from '@/mixins/CompanyMixin';
import DocumentSharing from '@/components/DocumentSharing.vue';
import DocumentPresentation from '@/components/DocumentPresentation.vue';

@Component({
  components: {DocumentPresentation, DocumentSharing},
})
export default class MetaValuation extends CompanyMixin {
  @Prop() readonly doc!: any;

  get agenda() {
    const res = [];
    for (const i of this.doc.Data.Children) {
      const child = this.doc.Data.Items.find((x: any) => x.Id === i);
      if (child.Kind === 'group' && child.Hidden !== true) {
        const v = this.getTitle(child.Type);
        if (v !== '') {
          res.push(v);
        }
      }
    }
    return res;
  }

  getTitle(type: string) {
    switch (type) {
      case 'cashflow': return 'Kassaflödesanalys';
      case 'schedule': return 'Tidsplan';
      case 'overview': return 'Översikt';
      case 'profitloss': return 'Resultaträkning';
      case 'balance': return 'Balansräkning';
      case 'compass': return 'Bolagskompass';
      case 'yearend': return 'Bokslut';
      case 'competition': return 'Konkurrentjämförelse';
      case 'gtAdvisory': return 'Vår rådgivning';
      case 'completion': return 'Avslutning';
      case 'sustainability': return 'Hållbarhet';

      case 'preClosingMeeting_thisYear': return 'Året hittills';
      case 'preClosingMeeting_remaining': return 'Helårsprognos';
      case 'preClosingMeeting_future': return 'Ägarplanering';
      case 'preClosingMeeting_schedule': return 'Tidplan';
      case 'preClosingMeeting_misc': return 'Övrigt';
      case 'preClosingMeeting_feedback': return 'Feedback';
      case 'preClosingMeeting_nextMeeting': return 'Nästa möte';
    }
    return '';
  }

  get showOutro() {
    return this.doc.Data.Items.find((x: any) => x.Type === 'custom_outro').Hidden !== true;
  }

  get method() {
    const s = this.doc.Data.Items.find((x: any) => x.Type === 'cashflow_method');
    switch (s.Method) {
      case 'complete':
        return 'Visar komplett metodik (7 slides)';
    }
    return 'Visar kompakt metodik (3 slides)';
  }

  get table() {
    const s = this.doc.Data.Items.find((x: any) => x.Type === 'cashflow_analysis');
    switch (s.Table) {
      case 'detailed':
        return 'Inkluderar detaljerad kassaflödestabell';
    }
    return 'Ingen kassaflödestabell inkluderas';
  }

  get rec() {
    const s = this.doc.Data.Items.find((x: any) => x.Type === 'cashflow_analysis');
    switch (s.Recommendation) {
      case 'financing':
        return 'Fokus på bolagets finansiering';
      case 'investments':
        return 'Fokus på bolagets investeringar';
      case 'workingcapital':
        return 'Fokus på bolagets rörelsekapital';
      case 'daytoday':
        return 'Fokus på operativ verksamhet';
    }
    return 'Ingen rekommendation lämnas';
  }
}
